import React, { useEffect, useState } from "react";
import { Link, useLocation,useNavigate } from "react-router-dom";
import BidServices from "../services/externalServices/bidServices";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Button,
  CircularProgress,
} from "@mui/material";

function CabRequestDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const [bids, setBids] = useState([]);
  const cabRequestDetails = location.state?.cabRequest;

  const cabRequestId = cabRequestDetails?.id;
  console.log("cabRequestDetails",cabRequestDetails)

  useEffect(() => {
    fetchBid();
  }, []);

  const fetchBid = async () => {
    try {
      const response = await BidServices.getAllBidsForCabRequest(cabRequestId);
      setBids(response || []);
    } catch (error) {
      console.log("Error getting the Bids", error);
    }
  };

  if (!cabRequestDetails) {
    return <Typography variant="h6">No details found.</Typography>;
  }

  const formatDate = (date) => new Date(date).toLocaleString();

  return (
    <Paper sx={{ padding: 4 }}>
      <Grid container direction="column" spacing={4}>
        {/* Back Button and Title */}
        <Grid item>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
            <Button
                onClick={() => navigate(-1)} // Navigate back to the previous page
                variant="text"
                style={{ textDecoration: "none", color: "inherit" }}
                startIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5em"
                    height="1.5em"
                    fill="currentColor"
                    viewBox="0 0 256 256"
                  >
                    <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                  </svg>
                }
              >
                </Button>
            </Grid>
            <Grid item>
              <Link
                to="/cabrequests"
                underline="hover"
                variant="subtitle2"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Typography variant="subtitle2">CabRequests</Typography>
              </Link>
            </Grid>
          </Grid>
        </Grid>

        {/* Cab Request Details */}
        <Grid item>
          <Typography variant="h4" gutterBottom>
            Cab Request Details
          </Typography>
          <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1">
                <strong>User Name: </strong>{" "}
                {cabRequestDetails.userName|| "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1">
                <strong>User Phone Number: </strong>{" "}
                {cabRequestDetails.user.phone_number|| "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1">
                <strong>Pickup Location:</strong>{" "}
                {cabRequestDetails.pickup_location?.title || "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1">
                <strong>Drop Location:</strong>{" "}
                {cabRequestDetails.drop_location?.title || "N/A"}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Bid Details */}
        <Grid item>
          <Typography variant="h4" gutterBottom>
            Bid Details
          </Typography>
          {bids.length === 0 ? (
            // <Typography>No bids available for this cab request.</Typography>
            <CircularProgress />
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>Driver Name</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Rider Fee</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Trip Id</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Base Amount</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Discount</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Tax</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Final Amount</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Is Accepted</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Placed On</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {bids.length >= 1 ? (
                    bids.map((bid, index) => (
                      <TableRow key={index}>
                        <TableCell>
                        <Link
                          to={`/riders/${bid.rider.id}`}
                          className="text-decoration-none text-dark font-weight-bold"
                        >
                          {bid.rider?.first_name} {bid.rider?.last_name}
                          
                        </Link>
                          
                        </TableCell>
                        <TableCell>₹{bid.riderFee}</TableCell>
                        <TableCell>
                        <Link
                          to={`/trip/${bid.tripId}`}
                          className="text-decoration-none text-dark font-weight-bold"
                        >
                          {bid.tripId}
                          
                        </Link>
                        </TableCell>

                        <TableCell>
                          ₹{bid.pricing?.baseAmount?.value || 0}
                        </TableCell>
                        <TableCell>
                          ₹{bid.pricing?.discount?.value || 0}
                        </TableCell>
                        <TableCell>
                          ₹{bid.pricing?.tax?.total?.value || 0}
                        </TableCell>
                        <TableCell>₹{bid.pricing?.finalAmount || 0}</TableCell>
                        <TableCell>{bid.isAccepted ? "Yes" : "No"}</TableCell>
                        <TableCell>{formatDate(bid.created_at)}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <>
                      {" "}
                      <Typography>
                        No bids available for this cab request.
                      </Typography>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
}

export default CabRequestDetails;
